import React, { Component } from 'react'

import DownshiftTypeahead from '../../DownshiftTypeahead'
import SimpleSelect from '../../SimpleSelect/'

// eslint-disable-next-line no-unused-vars
import styles from './styles.module.css'

export default class Controls extends Component {
  render() {
    const {
      // values
      place,
      tenure,
      amiMethod,
      costBurdenThreshold,
      // options
      places,
      tenureTypes,
      amiMethods,
      costBurdenThresholds,
      // callback functions
      onPlaceChange,
      onTenureChange,
      onAmiMethodChange,
      onCostBurdenThresholdChange
    } = this.props

    // console.log('places', places)

    const placesLabels = places.map(place => {
      return {
        label: place
      }
    })

    // console.log('this.props from Controls', this.props)

    return (
      <div className={styles.controls}>
        <div className={styles.filtersRow}>
          <SimpleSelect
            label={'Tenure'}
            value={tenure}
            options={tenureTypes}
            onChange={onTenureChange}
            classes={{
              root: styles.tenureSimpleSelect
            }}
          />
          <SimpleSelect
            label={'% AMI Category'}
            value={amiMethod}
            options={amiMethods}
            onChange={onAmiMethodChange}
            classes={{
              root: styles.simpleSelect
            }}
          />
          <SimpleSelect
            label={'Cost burden threshold'}
            value={costBurdenThreshold}
            options={costBurdenThresholds}
            onChange={onCostBurdenThresholdChange}
            classes={{
              root: styles.simpleSelect
            }}
          />
        </div>
        <div className={styles.filtersRow}>
          <DownshiftTypeahead
            data={placesLabels}
            placeholderText={'Search for a place'}
            onChange={onPlaceChange}
            initialSelectedItem={place}
            classes={{
              root: styles.placeFilter
            }}
          />
        </div>
      </div>
    )
  }
}
